import * as React from 'react';
import styled from 'styled-components';
import { ICollapsibleHeaderProps } from './CollapsibleHeader.types';
// @ts-ignore
import expandableArrow from '../../assets/icons/expandable-arrow.svg';
import { handleOnCollapse } from './CollapsibleHeader.logic';
import { NoneButton } from '../AttachmentTag/AttachmentTag';

const CollapsibleHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const MainContainer = styled.div<{ grid?: boolean }>`
  display: ${({ grid }) => `${grid ? 'contents' : 'block'}`};
`;

const CollapsibleHeader: React.FC<ICollapsibleHeaderProps> = (
  props: ICollapsibleHeaderProps
) => {
  const { className = '', onCollapse, children, isCollapsed, grid } = props;
  return (
    <MainContainer grid={grid} className={className}>
      <CollapsibleHeaderWrapper>
        {children}
        <NoneButton type="button" onClick={() => handleOnCollapse(onCollapse)}>
          <img
            src={expandableArrow}
            alt="arrow-icon"
            style={{ transform: `rotate(${isCollapsed ? '180deg' : '0deg'})` }}
          />
        </NoneButton>
      </CollapsibleHeaderWrapper>
    </MainContainer>
  );
};

export default CollapsibleHeader;
